import dataOf622453 from './_data/622453';
import dataOf523822 from './_data/523822';
import dataOf516809 from './_data/516809';
export var assignmentSummaryV2ByCourseId = {
    568749: dataOf622453,
    554121: dataOf523822,
    471204: dataOf516809
};
